import Swiper, { Pagination, Navigation } from "swiper";
Swiper.use([Pagination, Navigation])

class NewsSlider {
  constructor (el) {
    this.el = el
    this.slider = null
    this.pagination = this.el.querySelector('.js-slider-control-pagination')
    this.prev = this.el.querySelector('.js-slider-control-prev')
    this.next = this.el.querySelector('.js-slider-control-next')

    this.init()
  }

  init () {
    this.slider = new Swiper(this.el, {
      slidesPerView: 1,
      watchOverflow: true,
      observeParents: true,
      observer: true,
      observeParents: true,
      spaceBetween: 16,
      pagination: {
        el: this.pagination
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 32
        }
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', e => {
  const items = document.querySelectorAll('.js-news-slider')
  if ( items.length ) {
    items.forEach(el => {
      new NewsSlider(el)
    })
  }
})
